"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ChevronRight2 = _interopRequireDefault(require("@mui/icons-material/ChevronRight"));
var _Box2 = _interopRequireDefault(require("@mui/material/Box"));
var _Typography2 = _interopRequireDefault(require("@mui/material/Typography"));
var _Skeleton2 = _interopRequireDefault(require("@mui/material/Skeleton"));
var _Button3 = _interopRequireDefault(require("@mui/material/Button"));
var _notistack = require("notistack");
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _hooks = require("../../../hooks");
var _services = require("../../../services");
var _geogroupAvatar = require("../../geogroup-avatar");
var _medals = require("../medals");
var _sizes = require("../sizes");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function Leaderboard({
  Button: _Button,
  ownGeogroup,
  event,
  onOwnCompanyClick,
  selectLeaderboardSize
}) {
  const [leaderboard, setLeaderboard] = (0, _react.useState)();
  const [closeLeaderboard, setCloseLeaderboard] = (0, _react.useState)();
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const {
    enqueueSnackbar
  } = (0, _notistack.useSnackbar)();
  const {
    cancellablePromise,
    cancelPromises
  } = (0, _hooks.useCancellablePromise)();
  (0, _react.useEffect)(() => {
    const size = ownGeogroup === null ? 'large' : ownGeogroup?.companySize;
    if (size) getLeaderboard(size);
    return () => cancelPromises();
  }, [ownGeogroup]);
  async function getLeaderboard(size) {
    try {
      const {
        items
      } = await cancellablePromise(_services.EventService.getRanking(event.id, {
        page: 1,
        pageSize: 3,
        groupTypes: ['company'],
        returnedGroupsMode: 'excludeSubgroups',
        size: size === 'small' ? {
          max: 50
        } : size === 'medium' ? {
          min: 51,
          max: 500
        } : {
          min: 501
        }
      }));
      if (ownGeogroup && !items.find(({
        id
      }) => ownGeogroup.id === id)) {
        const {
          items
        } = await cancellablePromise(_services.EventService.getRanking(event.id, {
          page: 1,
          pageSize: 1,
          groupTypes: ['company'],
          returnedGroupsMode: 'excludeSubgroups',
          size: size === 'small' ? {
            max: 50
          } : size === 'medium' ? {
            min: 51,
            max: 500
          } : {
            min: 501
          },
          groupsIds: [ownGeogroup.id]
        }));
        setCloseLeaderboard(items);
      } else {
        setCloseLeaderboard([]);
      }
      setLeaderboard(items);
    } catch (err) {
      if (!(err instanceof Error) || err?.name !== 'CancelledPromiseError') {
        enqueueSnackbar(t('commons.challenge_details.server_error_awards'), {
          variant: 'error'
        });
      }
    }
  }
  if (leaderboard && leaderboard.length === 0) return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  const size = ownGeogroup === null ? 'large' : ownGeogroup?.companySize;
  const Button = _Button || _Button3.default;
  return /*#__PURE__*/_react.default.createElement(_Box2.default, {
    bgcolor: "#fff",
    borderRadius: 4,
    display: "flex",
    flexDirection: "column",
    gap: 3,
    padding: 3
  }, /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    fontWeight: 700
  }, size ? t(_sizes.leaderboardSizesMap[size].titleKey) : /*#__PURE__*/_react.default.createElement(_Skeleton2.default, {
    variant: "text",
    width: 200
  })), /*#__PURE__*/_react.default.createElement(_Box2.default, {
    display: "flex",
    flexDirection: "column",
    gap: 1
  }, size && leaderboard ? leaderboard.map((item, index) => /*#__PURE__*/_react.default.createElement(Item, {
    challengeType: event.challengeTemplate?.type,
    item: item,
    key: item.id,
    onOwnCompanyClick: onOwnCompanyClick,
    ownGeogroup: ownGeogroup,
    podiumIndex: index
  })) : [0, 1, 3].map(index => /*#__PURE__*/_react.default.createElement(Item, {
    challengeType: event.challengeTemplate?.type,
    key: index,
    podiumIndex: index
  }))), closeLeaderboard && closeLeaderboard.length > 0 && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Box2.default, {
    borderTop: "2px dashed #dde0e7"
  }), closeLeaderboard.map(item => /*#__PURE__*/_react.default.createElement(Item, {
    challengeType: event.challengeTemplate?.type,
    item: item,
    key: item.id,
    onOwnCompanyClick: onOwnCompanyClick,
    ownGeogroup: ownGeogroup
  }))), /*#__PURE__*/_react.default.createElement(_Box2.default, {
    display: "flex",
    justifyContent: "center"
  }, /*#__PURE__*/_react.default.createElement(Button, {
    color: "primary",
    disabled: !size,
    endIcon: /*#__PURE__*/_react.default.createElement(_ChevronRight2.default, null),
    onClick: () => size && selectLeaderboardSize(size),
    size: "medium",
    variant: "contained"
  }, t('commons.challenges.leaderboard.actions.see_leaderboard'))));
}
function Item({
  Button: _Button,
  ownGeogroup,
  challengeType,
  podiumIndex,
  item,
  onOwnCompanyClick
}) {
  const {
    getProgressValueWithUnit
  } = (0, _hooks.useChallenge)();
  const Button = _Button || _Button3.default;
  const medal = podiumIndex !== undefined && _medals.medals[podiumIndex] || null;
  return /*#__PURE__*/_react.default.createElement(_Box2.default, _extends({
    alignItems: "center",
    bgcolor: medal?.color,
    borderRadius: 2,
    display: "flex",
    gap: 1,
    padding: 2,
    sx: {
      justifyContent: 'flex-start',
      textAlign: 'left',
      textTransform: 'initial',
      color: 'initial'
    }
  }, onOwnCompanyClick && item && ownGeogroup && ownGeogroup.id === item.id ? {
    component: Button,
    onClick: onOwnCompanyClick
  } : {}), /*#__PURE__*/_react.default.createElement(_Box2.default, {
    display: "flex",
    flexShrink: 0,
    height: 24,
    justifyContent: "center",
    width: 30
  }, medal ? /*#__PURE__*/_react.default.createElement("img", {
    src: medal.icon,
    width: 24
  }) : /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    align: "center",
    fontWeight: 700
  }, item ? Math.max(item.rank, item.leaderboardIndex) : /*#__PURE__*/_react.default.createElement(_Skeleton2.default, {
    variant: "text",
    width: 24
  }))), /*#__PURE__*/_react.default.createElement(_geogroupAvatar.GeogroupAvatar, {
    geogroup: item,
    size: 48
  }), /*#__PURE__*/_react.default.createElement(_Box2.default, {
    display: "flex",
    flexDirection: "column",
    sx: {
      overflowY: 'hidden'
    }
  }, /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    noWrap: true,
    fontWeight: 700,
    title: item?.title,
    variant: "body2"
  }, item?.title || /*#__PURE__*/_react.default.createElement(_Skeleton2.default, {
    variant: "text",
    width: 200
  })), /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    variant: "caption"
  }, item ? getProgressValueWithUnit(challengeType || 'bttf', item.progressValue) : /*#__PURE__*/_react.default.createElement(_Skeleton2.default, {
    variant: "text",
    width: 100
  }))));
}
var _default = exports.default = Leaderboard;